import { WDSAIChatWidget } from "ee/modules/ui-builder/ui/wds/WDSAIChatWidget";

export const EEWDSWidgets = [WDSAIChatWidget];
